import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
});

/* ── Preview / demo mode ──────────────────────────────────────────────
   Active ONLY when REACT_APP_PREVIEW=1. Serves sample data from a local
   axios adapter so the UI can be previewed without a backend. No effect
   on a normal production build. */
if (process.env.REACT_APP_PREVIEW === '1') {
  const sites = [
    { id: 1, name: 'Aurora Store',    url: 'https://aurorastore.com',  country: 'USA',     status: 'online',  wp_version: '6.5.2', php_version: '8.2', response_ms: 142, agent_version: '2.1.1' },
    { id: 2, name: 'Nimbus Blog',     url: 'https://nimbusblog.io',    country: 'UK',      status: 'online',  wp_version: '6.4.3', php_version: '8.1', response_ms: 318, agent_version: '2.1.1' },
    { id: 3, name: 'Verde Market',    url: 'https://verdemarket.de',   country: 'Germany', status: 'warning', wp_version: '6.5.0', php_version: '8.0', response_ms: 612, agent_version: '2.0.1' },
    { id: 4, name: 'Coastal Studio',  url: 'https://coastalstudio.au', country: 'Australia',status:'offline',  wp_version: '6.3.1', php_version: '7.4', response_ms: null },
  ];
  const activity = [
    { id: 1, action: 'plugin_update', details: 'WooCommerce 8.6 → 8.7', site_name: 'Aurora Store',   result: 'success', created_at: '2026-05-29T09:12:00Z' },
    { id: 2, action: 'core_update',   details: 'WordPress 6.4 → 6.5',   site_name: 'Nimbus Blog',    result: 'success', created_at: '2026-05-29T08:40:00Z' },
    { id: 3, action: 'theme_update',  details: 'Astra 4.6 → 4.7',       site_name: 'Verde Market',   result: 'success', created_at: '2026-05-28T19:05:00Z' },
    { id: 4, action: 'health_check',  details: 'Site unreachable',      site_name: 'Coastal Studio', result: 'error',   created_at: '2026-05-28T17:22:00Z' },
    { id: 5, action: 'plugin_deploy', details: 'Deployed custom-seo.zip',site_name: 'Aurora Store',  result: 'success', created_at: '2026-05-28T14:01:00Z' },
  ];
  const stats = {
    sites:   { total: 4, online: 2 },
    plugins: { total: 86, updates: 7 },
    themes:  { total: 12, updates: 2 },
  };
  const user = { id: 1, name: 'Ali Raza', email: 'behnozali100@gmail.com', plan: 'pro' };

  const pluginsBySite = (id) => {
    const base = [
      { name: 'WooCommerce',        file: 'woocommerce/woocommerce.php', version: '8.6.1', new_version: '8.7.0', update_available: true,  active: true },
      { name: 'Yoast SEO',          file: 'wordpress-seo/wp-seo.php',    version: '22.3',  new_version: null,    update_available: false, active: true },
      { name: 'Elementor',          file: 'elementor/elementor.php',     version: '3.20', new_version: '3.21',  update_available: true,  active: true },
      { name: 'Contact Form 7',     file: 'contact-form-7/wp-c7.php',    version: '5.9',  new_version: null,    update_available: false, active: true },
      { name: 'WP Rocket',          file: 'wp-rocket/wp-rocket.php',     version: '3.15', new_version: '3.16',  update_available: id % 2 === 1, active: true },
      { name: 'Akismet',            file: 'akismet/akismet.php',         version: '5.3',  new_version: null,    update_available: false, active: false },
    ];
    return base;
  };
  const themesBySite = (id) => [
    { name: 'Astra',        slug: 'astra',       version: '4.6.0', new_version: '4.7.0', update_available: true,  active: true },
    { name: 'Twenty Twenty-Four', slug: 'twentytwentyfour', version: '1.1', new_version: null, update_available: false, active: false },
    { name: 'Kadence',      slug: 'kadence',     version: '1.1.9', new_version: id % 2 === 0 ? '1.2.0' : null, update_available: id % 2 === 0, active: false },
  ];
  const coreStatus = (id) => ({
    current_version: ['6.5.2', '6.4.3', '6.5.0', '6.3.1'][(id - 1) % 4],
    latest_version: '6.5.2',
    needs_update: id > 1,
  });

  const notifications = [
    { id: 1, type: 'site_down',        title: 'Coastal Studio is down',        message: 'https://coastalstudio.au did not respond during the latest health check.', site_name: 'Coastal Studio', read: false, created_at: '2026-05-29T10:05:00Z' },
    { id: 2, type: 'update_available', title: '7 new updates available',        message: '7 new plugin/theme updates were found across your sites.',               site_name: null,            read: false, created_at: '2026-05-29T08:00:00Z' },
    { id: 3, type: 'update_result',    title: 'Scheduled update complete',      message: '12 items updated across 3 sites.',                                       site_name: null,            read: false, created_at: '2026-05-28T03:00:00Z' },
    { id: 4, type: 'site_up',          title: 'Nimbus Blog is back online',     message: 'https://nimbusblog.io responded in 318ms.',                              site_name: 'Nimbus Blog',   read: true,  created_at: '2026-05-27T22:14:00Z' },
    { id: 5, type: 'update_available', title: '2 new updates available',        message: 'WooCommerce and Astra have new versions.',                               site_name: null,            read: true,  created_at: '2026-05-26T08:00:00Z' },
  ];
  const notificationSettings = {
    email_enabled: true, email_to: 'behnozali100@gmail.com',
    telegram_enabled: false, telegram_chat_id: '', telegram_bot_token: '',
    on_site_down: true, on_update_available: true, on_update_result: true,
  };
  const schedule = {
    enabled: true, frequency: 'weekly', run_hour: 3, day_of_week: 0,
    update_plugins: true, update_themes: true, update_core: false, backup_before: true,
    last_run: '2026-05-25T03:00:00Z',
  };
  const formCleanup = {
    enabled: true, frequency: 'weekly', run_hour: 4, day_of_week: 0,
    mode: 'older_than', retention_days: 30,
    last_run: '2026-05-25T04:00:00Z', last_deleted: 184,
  };
  const formStats = [
    { site_id: 1, site_name: 'Aurora Store',   available: true,  total: 1240, older_than: 870, oldest: '2024-11-02T09:00:00Z' },
    { site_id: 2, site_name: 'Nimbus Blog',    available: true,  total: 312,  older_than: 145, oldest: '2025-01-18T12:00:00Z' },
    { site_id: 3, site_name: 'Verde Market',   available: true,  total: 56,   older_than: 12,  oldest: '2025-04-21T07:30:00Z' },
    { site_id: 4, site_name: 'Coastal Studio', available: false, total: 0,    older_than: 0,   oldest: null },
  ];

  const mailbox = (id, email, inbox, junk, trash, toTrash, toPurge, auto = true) => ({
    id, email, label: null, imap_host: 'imap.hostinger.com', imap_port: 993, imap_secure: true,
    auto_cleanup: auto, retention_days: 7, trash_days: 3, folders: 'inbox,junk', keep_flagged: true,
    status: 'ok', status_note: null, last_checked: '2026-09-27T03:00:00Z',
    total: inbox + junk + trash, to_trash: toTrash, to_purge: toPurge,
    last_synced: '2026-09-27T03:00:00Z',
    folder_stats: [
      { folder: 'inbox', path: 'INBOX', total: inbox, to_trash: toTrash, to_purge: 0 },
      { folder: 'junk', path: 'INBOX.Junk', total: junk, to_trash: 0, to_purge: 0 },
      { folder: 'trash', path: 'INBOX.Trash', total: trash, to_trash: 0, to_purge: toPurge },
    ],
  });
  const mailboxes = [
    mailbox(1, 'info@treeservicewestminstermd.com', 3204, 812, 96, 3380, 62),
    mailbox(2, 'contact@customisesticker.com', 1806, 240, 31, 1644, 18),
    mailbox(3, 'hello@deckbuilderasheville.com', 902, 88, 12, 743, 7),
    mailbox(4, 'sales@custompackagingla.com', 2910, 1004, 210, 3301, 0, false),
    mailbox(5, 'info@partybusgreensboro.com', 980, 154, 32, 662, 21),
  ];
  const emailCleanup = {
    enabled: true, frequency: 'daily', run_hour: 3, day_of_week: 0,
    last_run: '2026-09-25T03:00:00Z', last_moved: 4112, last_purged: 3806,
  };
  const emailRuns = [
    { id: 1, email: 'info@treeservicewestminstermd.com', run_type: 'scheduled', moved: 3380, purged: 62, result: 'success', created_at: '2026-09-25T03:00:00Z' },
    { id: 2, email: 'contact@customisesticker.com', run_type: 'scheduled', moved: 1644, purged: 18, result: 'success', created_at: '2026-09-25T03:00:00Z' },
    { id: 3, email: 'sales@custompackagingla.com', run_type: 'scheduled', moved: 0, purged: 0, result: 'error', note: 'Invalid credentials', created_at: '2026-09-18T03:00:00Z' },
  ];

  const flatCached = (fn, extra) => sites.flatMap(s =>
    fn(s.id).map(x => ({ ...x, ...extra, site_id: s.id, site_name: s.name, country: s.country, last_synced: '2026-06-05T07:40:00Z' })));
  const uptimeMock = {
    hours: 168,
    stats: sites.map(s => ({ site_id: s.id, total: 336, up: s.status === 'offline' ? 301 : (s.status === 'warning' ? 328 : 336), avg_ms: s.response_ms || 900 })),
    series: Object.fromEntries(sites.map(s => [s.id, Array.from({ length: 30 }, (_, i) => ({
      ok: s.status === 'offline' ? (i < 24) : (s.status === 'warning' ? (i % 11 !== 4) : true),
      ms: (s.response_ms || 700) + (i % 5) * 60, t: '2026-06-05T07:00:00Z',
    }))])),
  };

  const match = (cfg) => {
    const url = (cfg.url || '').split('?')[0];
    if (url.endsWith('/deploy/prepare')) return { token: 'demo-token' };
    if (/\/sites\/\d+\/deploy-url$/.test(url)) return { success: true };
    if (url.endsWith('/agent/version')) return { version: '2.2.0' };
    if (url.endsWith('/agent/deploy-all')) return { version: '2.1.1', results: sites.map(s => ({ site_id: s.id, site: s.name, success: s.status !== 'offline', folder: 'wp-manager-agent', agent: '2.1.1', error: s.status === 'offline' ? 'Site unreachable' : undefined })) };
    if (url.endsWith('/health/dropins/fix')) return { sites: 1, removed: 1, results: [{ site_id: 3, site: 'Verde Market', success: true, removed: ['object-cache.php'], resynced: true }] };
    if (/\/sites\/\d+\/health\/dropins\/fix$/.test(url)) return { site_id: 3, site: 'Verde Market', success: true, removed: ['object-cache.php'], resynced: true };
    if (url.endsWith('/health/dropins')) return {
      scanned: 4, affected: 1,
      results: sites.map(s => s.id === 3
        ? { site_id: s.id, site: s.name, url: s.url, supported: true, reachable: true, needs_fix: true,
            printing_errors: true, broken: ['object-cache.php'],
            reasons: ['LiteSpeed Cache is no longer installed, but its object-cache.php is still in wp-content — it errors on every request.'],
            stray_output: 'Can NOT find LSCWP path for object cache initialization in /home/u1/public_html/wp-content/object-cache.php', warnings: [] }
        : { site_id: s.id, site: s.name, url: s.url, supported: true, reachable: s.status !== 'offline', needs_fix: false, broken: [], warnings: [],
            error: s.status === 'offline' ? 'Site unreachable' : undefined }),
    };
    if (url.endsWith('/email/accounts/test')) return { ok: true, folders: [
      { folder: 'inbox', path: 'INBOX', total: 3204 }, { folder: 'junk', path: 'INBOX.Junk', total: 812 },
      { folder: 'trash', path: 'INBOX.Trash', total: 96 }, { folder: 'sent', path: 'INBOX.Sent', total: 410 },
    ] };
    if (url.endsWith('/email/accounts')) return mailboxes;
    if (url.endsWith('/email/cleanup')) return emailCleanup;
    if (url.endsWith('/email/runs')) return emailRuns;
    if (url.includes('/email/')) return { moved: 9730, purged: 108, mailboxes: 4, results: [] };
    if (url.endsWith('/plugins/all')) return flatCached(pluginsBySite);
    if (url.endsWith('/themes/all'))  return flatCached(themesBySite);
    if (url.endsWith('/uptime')) return uptimeMock;
    if (url.includes('/auth/me') || url.includes('/auth/login') || url.includes('/auth/register'))
      return cfg.url.includes('login') || cfg.url.includes('register') ? { token: 'demo', user } : user;
    if (url.endsWith('/notifications/unread-count')) return { count: notifications.filter(n => !n.read).length };
    if (url.endsWith('/notifications/delete')) return { deleted: (JSON.parse(cfg.data || '{}').ids || []).length || notifications.length };
    if (url.endsWith('/notifications/read-all') || /\/notifications\/\d+/.test(url)) return { success: true };
    if (url.endsWith('/notifications')) return notifications;
    if (url.endsWith('/auth/registration-status')) return { allowed: false };
    if (url.endsWith('/auth/forgot-password') || url.endsWith('/auth/reset-password')) return { success: true };
    if (url.endsWith('/auth/2fa/status')) return { enabled: false };
    if (url.endsWith('/auth/2fa/setup')) return { secret: 'JBSWY3DPEHPK3PXP', qr: 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160"><rect width="160" height="160" fill="white"/><text x="80" y="85" font-size="12" text-anchor="middle" fill="black">QR (demo)</text></svg>') };
    if (url.endsWith('/auth/2fa/enable')) return { enabled: true, backup_codes: ['a1b2-c3d4','e5f6-7890','1234-abcd','dead-beef','9f8e-7d6c','5b4a-3c2d','0011-2233','4455-6677','8899-aabb','ccdd-eeff'] };
    if (url.endsWith('/auth/2fa/disable')) return { enabled: false };
    if (url.endsWith('/auth/logout-all')) return { success: true };
    if (url.endsWith('/security/logins')) return [
      { email: 'nexorabrandstools@gmail.com', ip: '203.0.113.24', success: true,  reason: null,           created_at: '2026-07-08T09:20:00Z' },
      { email: 'nexorabrandstools@gmail.com', ip: '203.0.113.24', success: false, reason: 'bad_password', created_at: '2026-07-08T09:19:30Z' },
      { email: 'attacker@spam.ru',            ip: '198.51.100.7', success: false, reason: 'locked',       created_at: '2026-07-08T04:11:00Z' },
      { email: 'attacker@spam.ru',            ip: '198.51.100.7', success: false, reason: 'no_user',      created_at: '2026-07-08T04:10:20Z' },
    ];
    if (url.endsWith('/app-settings')) return { allow_registration: false };
    if (url.endsWith('/notification-settings/test')) return { success: true };
    if (url.endsWith('/notification-settings')) return notificationSettings;
    if (url.endsWith('/schedule/run-now')) return { success: true, updated: 5, failed: 0, sites: 3 };
    if (url.endsWith('/schedule')) return schedule;
    if (url.endsWith('/exclusions/bulk')) return { excluded: true, exclusions: [
      { site_id: 1, plugin_file: 'wp-rocket/wp-rocket.php' },
      { site_id: 2, plugin_file: 'wp-rocket/wp-rocket.php' },
      { site_id: 3, plugin_file: 'wp-rocket/wp-rocket.php' },
      { site_id: 4, plugin_file: 'wp-rocket/wp-rocket.php' },
    ] };
    if (url.endsWith('/exclusions/toggle')) return { excluded: true };
    if (url.endsWith('/exclusions')) return [
      { site_id: 1, plugin_file: 'wp-rocket/wp-rocket.php' },
      { site_id: 2, plugin_file: 'wp-rocket/wp-rocket.php' },
    ];
    if (url.endsWith('/form-cleanup/run-now')) return { success: true, deleted: 1027, sites: 3 };
    if (url.endsWith('/form-cleanup/stats')) return formStats;
    if (url.endsWith('/form-cleanup')) return formCleanup;
    if (url.endsWith('/stats')) return stats;
    if (url.endsWith('/activity')) return activity;
    if (url.endsWith('/sites')) return sites;
    const m = url.match(/\/sites\/(\d+)\/(plugins|themes|core\/status)/);
    if (m) {
      const id = parseInt(m[1], 10);
      if (m[2] === 'plugins') return pluginsBySite(id);
      if (m[2] === 'themes') return themesBySite(id);
      return coreStatus(id);
    }
    if (url.includes('/ping')) return { status: 'online' };
    return {};
  };

  API.defaults.adapter = (cfg) =>
    new Promise((resolve) =>
      setTimeout(() => resolve({ data: match(cfg), status: 200, statusText: 'OK', headers: {}, config: cfg }), 120)
    );
}

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('wpm_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(
  r => r.data,
  err => {
    const url = err.config?.url || '';
    // Only auto-logout on an EXPIRED SESSION (401 on a protected call).
    // Login / 2FA / password endpoints return 401s that the page handles
    // itself — never hard-redirect on those (that was bouncing the 2FA
    // step back to the sign-in screen).
    const isAuthCall = url.includes('/auth/');
    if (err.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem('wpm_token');
      window.location.href = '/login';
    }
    return Promise.reject(err.response?.data || err);
  }
);

// Auth
export const login    = (email, password, code) => API.post('/auth/login', { email, password, code });
export const register = (name, email, password) => API.post('/auth/register', { name, email, password });
export const getMe    = () => API.get('/auth/me');

// Two-factor auth (TOTP)
export const get2faStatus = () => API.get('/auth/2fa/status');
export const setup2fa     = () => API.post('/auth/2fa/setup');
export const enable2fa    = (code) => API.post('/auth/2fa/enable', { code });
export const disable2fa   = (code) => API.post('/auth/2fa/disable', { code });
export const logoutEverywhere = () => API.post('/auth/logout-all');
export const getRegistrationStatus = () => API.get('/auth/registration-status');
export const forgotPassword = (email) => API.post('/auth/forgot-password', { email });
export const resetPassword  = (token, password) => API.post('/auth/reset-password', { token, password });

// App settings (admin)
export const getAppSettings  = () => API.get('/app-settings');
export const saveAppSettings = (data) => API.put('/app-settings', data);
export const getLoginLog     = () => API.get('/security/logins');

// Sites
export const getSites  = () => API.get('/sites');
export const addSite   = (data) => API.post('/sites', data);
export const deleteSite  = (id) => API.delete(`/sites/${id}`);
export const updateSite  = (id, data) => API.put(`/sites/${id}`, data);
export const pingSite  = (id) => API.post(`/sites/${id}/ping`);
export const pingAll   = () => API.post('/sites/ping-all');

// Uptime history
export const getUptime = (hours = 168) => API.get(`/uptime?hours=${hours}`);

// Agent self-update (push bundled agent to all sites, in place)
export const getAgentVersion = () => API.get('/agent/version');
export const deployAgents    = () => API.post('/agent/deploy-all');
export const downloadAgent   = () => API.get('/agent/download', { responseType: 'blob' });

// Site health — broken cache drop-ins (the LiteSpeed object-cache.php error
// that stops a site's plugin list from loading)
export const scanDropins    = () => API.get('/health/dropins');
export const getSiteHealth  = (siteId) => API.get(`/sites/${siteId}/health`);
export const fixSiteDropins = (siteId, files) => API.post(`/sites/${siteId}/health/dropins/fix`, files ? { files } : {});
export const fixAllDropins  = (site_ids) => API.post('/health/dropins/fix', site_ids ? { site_ids } : {});

// Plugins
export const getAllPluginsCached = () => API.get('/plugins/all');
export const getAllThemesCached  = () => API.get('/themes/all');
export const getPlugins     = (siteId) => API.get(`/sites/${siteId}/plugins`);
export const updatePlugin   = (siteId, plugin) => API.post(`/sites/${siteId}/plugins/update`, { plugin });
export const updateAllPlugins = (siteId) => API.post(`/sites/${siteId}/plugins/update-all`);
export const deployPlugin   = (formData) => API.post('/deploy/plugin', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
// Deploy-by-download (bypasses upload firewalls): upload once, sites fetch it
export const deployPrepare  = (formData) => API.post('/deploy/prepare', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deployToSite   = (siteId, token, type) => API.post(`/sites/${siteId}/deploy-url`, { token, type });

// Themes
export const getThemes   = (siteId) => API.get(`/sites/${siteId}/themes`);
export const updateTheme = (siteId, theme) => API.post(`/sites/${siteId}/themes/update`, { theme });
export const deployTheme = (formData) => API.post('/deploy/theme', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Core
export const getCoreStatus = (siteId) => API.get(`/sites/${siteId}/core/status`);
export const updateCore    = (siteId) => API.post(`/sites/${siteId}/core/update`);

// Stats & Activity
export const getStats    = () => API.get('/stats');
export const getActivity = (limit = 50) => API.get(`/activity?limit=${limit}`);

// Notifications
export const getNotifications        = (limit = 30) => API.get(`/notifications?limit=${limit}`);
export const getUnreadCount          = () => API.get('/notifications/unread-count');
export const markNotificationRead    = (id) => API.post(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => API.post('/notifications/read-all');
export const deleteNotification      = (id) => API.delete(`/notifications/${id}`);
export const deleteNotifications     = (ids) => API.post('/notifications/delete', { ids });
export const clearAllNotifications   = () => API.post('/notifications/delete', { all: true });
export const getNotificationSettings = () => API.get('/notification-settings');
export const saveNotificationSettings = (data) => API.put('/notification-settings', data);
export const sendTestNotification    = () => API.post('/notification-settings/test');

// Auto-update schedule
export const getSchedule    = () => API.get('/schedule');
export const saveSchedule   = (data) => API.put('/schedule', data);
export const runScheduleNow = () => API.post('/schedule/run-now');

// Update exclusions (locked plugins)
export const getExclusions   = () => API.get('/exclusions');
export const toggleExclusion = (site_id, plugin_file) => API.post('/exclusions/toggle', { site_id, plugin_file });
export const bulkExclusion   = (plugin_file, excluded) => API.post('/exclusions/bulk', { plugin_file, excluded });

// Email cleanup (business mailboxes over IMAP)
export const getMailboxes      = () => API.get('/email/accounts');
export const testMailbox       = (data) => API.post('/email/accounts/test', data);
export const addMailbox        = (data) => API.post('/email/accounts', data);
export const updateMailbox     = (id, data) => API.put(`/email/accounts/${id}`, data);
export const applyMailboxRule  = (data) => API.put('/email/accounts', data);
export const deleteMailbox     = (id) => API.delete(`/email/accounts/${id}`);
export const refreshMailbox    = (id) => API.post(`/email/accounts/${id}/refresh`);
export const refreshMailboxes  = () => API.post('/email/refresh');
export const cleanMailbox      = (id, opts) => API.post(`/email/accounts/${id}/clean`, opts || {});
export const cleanMailboxes    = (opts) => API.post('/email/clean', opts || {});
export const getEmailCleanup   = () => API.get('/email/cleanup');
export const saveEmailCleanup  = (data) => API.put('/email/cleanup', data);
export const getEmailRuns      = (limit) => API.get(`/email/runs${limit ? `?limit=${limit}` : ''}`);

// Elementor form-submission cleanup
export const getFormCleanup    = () => API.get('/form-cleanup');
export const saveFormCleanup   = (data) => API.put('/form-cleanup', data);
export const runFormCleanupNow = () => API.post('/form-cleanup/run-now');
export const getFormStats      = (days) => API.get(`/form-cleanup/stats${days ? `?days=${days}` : ''}`);
